import { render, staticRenderFns } from "./ModalMicroArea.vue?vue&type=template&id=36273258"
import script from "./ModalMicroArea.vue?vue&type=script&lang=js"
export * from "./ModalMicroArea.vue?vue&type=script&lang=js"
import style0 from "./ModalMicroArea.vue?vue&type=style&index=0&id=36273258&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports